import utils from 'utils'
class openedInvmodalUploadCtrl {
    constructor($scope, $uibModal, $uibModalInstance, items1, httpRequest, logger, sweetalert, $timeout, resultTipService) {
        $scope.uploadType = items1.uploadType
        $scope.modalParam = {
            totalMoney: 0,
            uploadListData: [],
        }
        let batchNo = ''
        // 字典字段
        httpRequest.get_dictByTypeArr(['ivat_inv_type', 'deduction_flag', 'verify_status', 'ivat_file_ocr_result', 'ovat_ocr_match_status']).then((res) => {
            $scope.dictionary = res.data.value
            $scope.dictionary.ivat_inv_type.push({
                enumCode: '-1',
                enumName: '未识别发票类型',
            })
        })
        // 扫描发票
        let loading
        $scope.scanInvoice = function scanInvoice() {
            loading = window.layer.msg('正在扫描中，请勿有其他操作', {
                time: 0,
                skin: 'layer-loading-self',
                icon: 16,
                shade: 0.5,
            })
            httpRequest
                .post_getScanInitParam({
                    host: window.location.origin,
                    scanType: '41',
                    imgType: '0',
                    dataSource: '1',
                    scanSource: '2',
                    businessType: '1',
                    // imgPath:'D:\\38815074+20171226+粤通卡+123.48.pdf'
                })
                .then(
                    (res) => {
                        const hostUrl = REAL_URL.split(':')
                        const _url = `${`${hostUrl[0]}:${hostUrl[1]}`}:${res.data.value.port}/ScanFP`
                        // console.log(_url)
                        $.post({
                            url: _url,
                            data: {
                                SID: res.data.value.SID,
                                SIDParam: res.data.value.SIDParam,
                                Config: res.data.value.Config,
                            },
                            cache: false,
                            charset: 'GBK',
                            callbackParameter: 'callback',
                            timeout: 86400000,
                            success(res) {
                                const json = JSON.parse(res)
                                if (json.retcode == '1') {
                                    httpRequest
                                        .post_scanEndCallBack({
                                            responseBody: json.ResponseStr,
                                            scanType: '41',
                                        })
                                        .then((res) => {
                                            batchNo = res.data.value.batchNo
                                            $scope.getInputBatchInfo(res.data.value.batchNo)
                                        })
                                } else {
                                    logger.logError('扫描异常！')
                                    window.layer.close(loading)
                                }
                            },
                            error(XMLHttpRequest, textStatus) {
                                logger.logError('没有连接扫描仪！')
                                window.layer.close(loading)
                            },
                        })
                    },
                    () => {
                        window.layer.close(loading)
                    }
                )
        }
        // 定时查询扫描
        $scope.getInputBatchInfo = function getInputBatchInfo(batchNo) {
            httpRequest
                .get_getInputBatchInfo({
                    batchNo: batchNo || '',
                })
                .then((res) => {
                    if (res.data.value) {
                        if (res.data.value.batchStatus != 2) {
                            $scope.scanTimeout = $timeout(() => {
                                $scope.getInputBatchInfo(res.data.value.batchNo)
                            }, 5000)
                        } else {
                            if (res.data.value.asyncType == 2) {
                                let inputCount = res.data.value.inputCount
                                $scope.showMsg(inputCount)
                            }
                            $scope.batchNo = res.data.value.batchNo
                            let param = {
                                pageNum: 1,
                                pageSize: 200,
                                param: {
                                    batchNo: res.data.value.batchNo,
                                },
                            }
                            httpRequest.post_selectPageOvatInputBatchList(param).then((item) => {
                                $timeout.cancel($scope.scanTimeout)
                                window.layer.close(loading)
                                $scope.modalParam.uploadListData = $scope.modalParam.uploadListData.concat(item.data)
                                $scope.caculateMoney() // 重新计算总金额
                            })
                        }
                    } else {
                        $scope.scanTimeout = $timeout(() => {
                            $scope.getInputBatchInfo()
                        }, 5000)
                    }
                })
        }
        $scope.caculateMoney = function () {
            $scope.modalParam.totalMoney = 0
            $scope.modalParam.uploadListData.forEach((i) => {
                $scope.modalParam.totalMoney += i.adValoremTotal ? +i.adValoremTotal : 0
            })
        }
        //展示提示弹框
        $scope.showMsg = function (inputCount) {
            let html = `<div style='width:100%;text-align:center'>本次新增票据<span style='color:#e4393c'>${inputCount}</span>张！</div>已开启定时识别+查验，系统将在后台依次排队处理这些票据，请过几分钟后再过来查看识别及查验结果！`
            window.layer.open({
                title: '提示',
                content: html,
                btn: ['确定'],
                resize: false,
                closeBtn: 0,
                shadeClose: false,
                move: false,
                yes(index) {
                    window.layer.close(index)
                    $uibModalInstance.close()
                },
            })
        }
        // 本地上传
        $scope.uploadFiles = function uploadFiles(files, errorFile) {
            if (!files.length || errorFile.length) {
                if (errorFile.length) {
                    logger.logError('上传失败,文件大小不得超过50M')
                }
                return
            }
            const formData = new FormData()
            for (let i = 0; i < files.length; i++) {
                formData.append('file', files[i])
            }
            formData.append('dataSource', '1') //$scope.dataSource
            formData.append('businessType', '1')
            $scope.showloading = true
            httpRequest.post_uploadPdf(formData).then(
                (res) => {
                    $scope.showloading = false
                    if (!res.data.success) {
                        return logger.logError(res.data.message || '上传失败')
                    }
                    if (res.data.value && res.data.value.asyncType == 2) {
                        let inputCount = res.data.value.inputCount
                        $scope.showMsg(inputCount)
                    }
                    $scope.batchNo = res.data.value.batchNo
                    $scope.imageList(res.data.value.batchNo, 1)
                },
                (response) => {
                    $scope.showloading = false
                    if (response.status > 0) {
                        // 关闭loading
                        layer.close()
                        logger.logError('上传失败 ')
                    }
                },
                (evt) => {
                    // file.progress = Math.min(100, parseInt((100.0 * evt.loaded) / evt.total))
                }
            )
        }
        $scope.delInvoiceByidArr = function (batchNo, close) {
            httpRequest.post_clearInvalidOvatOcrImage(batchNo).then((res) => {
                if (res.data.success) {
                    logger.logSuccess('移除成功')
                    $scope.caculateMoney()
                    if (close) {
                        $uibModalInstance.close()
                    }
                }
            })
        }
        $scope.delInvoice = function (item, $event) {
            $event.stopPropagation()
            httpRequest.post_batchDeleteOvatOcrImageByImageKey([item.imageKey]).then((res) => {
                logger.logSuccess('移除成功')
                $scope.imageList($scope.batchNo, 0)
            })
        }
        $scope.imageList = (batchNo, type) => {
            let param = {
                pageNum: 1,
                pageSize: 200,
                param: {
                    batchNo,
                },
            }
            httpRequest.post_selectPageOvatInputBatchList(param).then((res) => {
                if (type) {
                    $scope.modalParam.uploadListData = $scope.modalParam.uploadListData.concat(res.data.value.list)
                } else {
                    $scope.modalParam.uploadListData = res.data.value.list
                }

                $scope.caculateMoney() // 重新计算总金额
            })
        }
        $scope.ok = () => {
            const listLen = $scope.modalParam.uploadListData.length
            if (listLen) {
                let isMatchFailure = $scope.modalParam.uploadListData.some((el) => el.matchStatus == '2')
                const confirmTips = isMatchFailure
                    ? '存在匹配失败的发票影像，确定后系统会将匹配成功的发票影像自动关联至已开具发票，关联后可下载影像。匹配失败的发票影像将不会关联保存，系统将自动删除，如仍需上传影像，请选择对应发票进行单张影像指定上传。'
                    : '系统会将匹配成功查验通过的发票影像自动关联至已开具发票，关联后可下载影像。如关联有误，可选择对应发票数据，删除影像后重新上传。'
                sweetalert.confirm('确认提醒', confirmTips).then(
                    () => {
                        if (isMatchFailure) {
                            let imageKeyList = $scope.modalParam.uploadListData.map((el) => el.imageKey)
                            httpRequest.post_batchDeleteOvatOcrImageByImageKey(imageKeyList).then((res) => {})
                        }
                        $uibModalInstance.close()
                    },
                    () => {}
                )
            }
        }
        $scope.cancel = () => {
            if ($scope.modalParam.uploadListData.length > 0) {
                // 上传或者扫描
                sweetalert.confirm('删除提醒', '关闭弹窗后单据会被删除，确认移除上传单据？').then(
                    () => {
                        $scope.delInvoiceByidArr($scope.batchNo, true)
                    },
                    () => {}
                )
            } else {
                $uibModalInstance.close()
            }
        }
    }
}

openedInvmodalUploadCtrl.$inject = ['$scope', '$uibModal', '$uibModalInstance', 'items1', 'httpRequest', 'logger', 'sweetalert', '$timeout', 'resultTipService']
export default openedInvmodalUploadCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/billManage/openedInvoice/openedInvmodalUploadCtrl.js